/** V1: beneficiary portal/onboarding hidden; re-enable in Phase 2. */
export const ENABLE_BENEFICIARY_PORTAL = false;
